module.exports = __webpack_public_path__ + "images/modern-6-bbe059a6bdadc336dad465f58cdd22b0.jpg";